<template>
  <div id="app">  
    <MainHeader     v-if="showGlobalLayout" />
    <TopMenu        v-if="showGlobalLayout" />
    <SideMenu       v-if="showGlobalLayout" /> 
     
    <div class="content">
      <router-view v-slot="{ Component }">
        <transition name="fade" mode="out-in">
          <component :is="Component" class="router-view" />
        </transition>
      </router-view>
    </div>
 
    <MainFooter      v-if="showGlobalLayout" />
    <MaintenanceModal
      v-if="isMaintenanceMode && showGlobalLayout"
    />
  </div>
</template>

<script>
import MainHeader        from './components/MainHeader.vue';
import MainFooter        from './components/MainFooter.vue';
import SideMenu          from './components/menus/SideMenu.vue';
import MaintenanceModal  from './components/MaintenanceModal.vue';
import TopMenu           from './components/menus/TopMenu.vue';
import axios             from 'axios';
import { eventBus }      from './utils/eventBus';

export default {
  name: 'App',
  components: {
    MainHeader,
    MainFooter,
    SideMenu,
    MaintenanceModal,
    TopMenu
  },
  data() {
    return {
      isMaintenanceMode: true,
      showGlobalLayout : true
    };
  },
  created() {
    this.checkMaintenanceMode();
  // this.startTokenCheck();
    eventBus.on('kasolcum-visible', this.handleKasolcumVisibility);
    eventBus.on('language-changed', this.handleLanguageChanged);

    const savedLang = localStorage.getItem('selectedLanguage');
    if (savedLang && ['tr', 'en'].includes(savedLang)) {
      this.$i18n.locale = savedLang;
    }
  },
  beforeUnmount() {
    eventBus.off('kasolcum-visible', this.handleKasolcumVisibility);
    eventBus.off('language-changed', this.handleLanguageChanged);
  },
  methods: {
    async checkMaintenanceMode() {
      try {
        const { data } = await axios.get('/auth/web-status/1');
        this.isMaintenanceMode = !data?.is_active;
      } catch (err) {
        console.error('Maintenance check failed:', err);
        this.isMaintenanceMode = true;
      }
    },
   // startTokenCheck() {
   //   setInterval(() => {
   //     const token = localStorage.getItem('token');
   //     const currentPath = this.$router.currentRoute.value.path;
   //     if (!token && currentPath !== '/kayitol') {
   //       this.$router.push('/login');
   //     }
   //   }, 200);
   // },
    
    handleKasolcumVisibility(isKasolcumVisible) {
      this.showGlobalLayout = !isKasolcumVisible;
    },
    handleLanguageChanged(code) {
      if (code && ['tr', 'en'].includes(code)) {
        this.$i18n.locale = code;
      } else {
        this.$i18n.locale = 'tr';
      }
      const titleKey = this.$route?.meta?.titleKey;
      if (titleKey) {
        document.title = this.$t(titleKey);
      }
    }
  }
};
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
